<template>
  <div>
    <el-container>
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <el-form>
          <el-form-item label="corpid" :label-width="formLabelWidth">
            <el-input v-model="corpid" auto-complete="off" :maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="corpsecret" :label-width="formLabelWidth">
            <el-input v-model="corpsecret" auto-complete="off" :maxlength="80"></el-input>
          </el-form-item>
          <el-form-item label="agentId" :label-width="formLabelWidth">
            <el-input v-model="agentId" auto-complete="off" :maxlength="80"></el-input>
          </el-form-item>
          <el-form-item label="mch_id" :label-width="formLabelWidth">
            <el-input v-model="mch_id" auto-complete="off" :maxlength="80"></el-input>
          </el-form-item>
          <el-form-item label="mch_key" :label-width="formLabelWidth">
            <el-input v-model="mch_key" auto-complete="off" :maxlength="80"></el-input>
          </el-form-item>
          <el-form-item label="wxappid" :label-width="formLabelWidth">
            <el-input v-model="wxappid" auto-complete="off" :maxlength="80"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="qdCreateEW">确 定</el-button>
        </div>
      </el-dialog>
      <el-header>
        <div>
          <el-button type="primary" @click="openCreateEW()" size="small">创建企业微信</el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="corpid"
              label="corpid"
              width="300">
            </el-table-column>
            <el-table-column
              prop="corpsecret"
              label="corpsecret"
              width="280">
            </el-table-column>
            <el-table-column
              prop="agentId"
              label="agentId"
              width="280">
            </el-table-column>
            <el-table-column
              prop="mch_id"
              label="mch_id"
              width="280">
            </el-table-column>
            <el-table-column
              prop="wxappid"
              label="wxappid"
              width="280">
            </el-table-column>
            <el-table-column
              prop="create_time"
              :formatter="formatTime"
              label="创建时间"
              width="220">
            </el-table-column>
            <el-table-column
              prop="update_time"
              :formatter="formatTime"
              label="最后修改时间"
              width="220">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="updateEW(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import apiController from '@/api/enterpriseWechat'
  export default {
    name: 'addEnterpriseWechat',
    data(){
      return {
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        dialogFormVisible: false,
        formLabelWidth: '120px',
        corpid: '',
        corpsecret: '',
        agentId: '',
        mch_id: '',
        mch_key: '',
        wxappid: ''
      }
    },
    components: {
    },
    created(){
    },
    methods:{
      updateEW(index, row){
        this.corpid = row.corpid;
        this.corpsecret = row.corpsecret;
        this.agentId = row.agentId;
        this.dialogFormVisible = true
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      openCreateEW() {
        this.corpid = ''
        this.corpsecret = ''
        this.agentId = ''
        this.dialogFormVisible = true
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      isAjax: async function(){
        await apiController.getEnterpriseWechat({
            params:{
              limit: this.count0,
              page: this.currentPage0
            }
          })
          .then(res => {
            let { data, code } = res.data
            if (code === 'Success'){
              this.tableData = data
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      qdCreateEW: async function() {
        if (this.corpid === '') {
          this.$message({
            message: "请录入corpid",
            type: 'warning'
          });
        } else if (this.corpsecret === '') {
          this.$message({
            message: "请录入corpsecret",
            type: 'warning'
          });
        } else if (this.agentId === '') {
          this.$message({
            message: "请录入agentId",
            type: 'warning'
          });
        }  else {
          await apiController.addEnterpriseWechat({
            corpid: this.corpid,
            corpsecret: this.corpsecret,
            agentId: this.agentId
          }).then(res => {
            console.log(res)
            let { message } = res.data
            this.$message({
              message: message,
              type: 'success'
            });
            this.dialogFormVisible = false
            this.isAjax()
          }).catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
        }
      }
    },
    mounted(){
      this.isAjax()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/enterpriseWechat/addEnterpriseWechat.vue